import { create } from 'zustand';
import { TLockItem } from '@/components/tour/game/NewLocks/LockInfoPopup/types';

interface GameState {
  lockTimer: { value: number; running: boolean };
  lockInfoPopupStatus: null | TLockItem;
  gamePoints: number;
  gameSoundOn: boolean;
  gameSoundVolume: number;
}

interface GameActions {
  setLockTimer: (timer: { value: number; running: boolean }) => void;
  setLockInfoPopupStatus: (status: null | TLockItem) => void;
  setGamePoints: (points: number) => void;
  setGameSoundOn: (soundOn: boolean) => void;
  setGameSoundVolume: (volume: number) => void;
}

export const useGameStore = create<GameState & GameActions>((set) => ({
  // State
  lockTimer: { running: false, value: 0 },
  lockInfoPopupStatus: null,
  gamePoints: 0,
  gameSoundOn: true,
  gameSoundVolume: 0.5,

  // Actions
  setLockTimer: (timer) => set({ lockTimer: timer }),
  setLockInfoPopupStatus: (status) => set({ lockInfoPopupStatus: status }),
  setGamePoints: (points) => set({ gamePoints: points }),
  setGameSoundOn: (soundOn) => set({ gameSoundOn: soundOn }),
  setGameSoundVolume: (volume) => set({ gameSoundVolume: volume }),
}));
